import jwtDecode from 'jwt-decode'
import { computed } from 'vue'
import { useLocalStorage } from '@vueuse/core'

export interface Token {
  exp: number;
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role': string
}

const rawToken = useLocalStorage<string | null>('token', null)
function storeToken(token: string | null) {
  rawToken.value = token
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const decodedToken = computed(() => rawToken.value && jwtDecode<Token>(rawToken.value))
const token = computed(() => rawToken.value)
const isAuthenticated = computed(() => !!decodedToken.value && (!decodedToken.value.exp || (Date.now() <= decodedToken.value.exp * 1000)))
const isAdmin = computed(() => decodedToken.value && decodedToken.value['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] === 'Admin')

export { storeToken, decodedToken, isAuthenticated, token, isAdmin }
